import {APP} from './types';

export const getApp = data => ({
  type: APP,
  payload: data,
});
